module.exports = __webpack_public_path__ + "static/media/home-illustration-desktop.fa00c455.png";